import { FC } from 'react'
import { Icon } from '@iconify/react'
import { Button } from '@pepper/ui'

import GoogleIntegrationButton from 'components/GoogleIntegrationButton'

import s from './SkipAccountIntegration.module.css'

type Props = {
  companyId: string
  skipped: 'googleAccount' | 'gaProperty' | 'gscProperty'
  onSkipConnection: () => void
}

export const SkipAccountIntegration: FC<Props> = ({
  companyId,
  skipped,
  onSkipConnection,
}) => {
  return (
    <div className={s.wrapper}>
      <div className={s.iconWrapper}>
        <Icon icon="lucide:alert-triangle" width={24} />
      </div>
      <div className={s.body}>
        <div className={s.header}>Are you sure?</div>
        <div className={s.description}>
          <div>
            You will miss out on features like{' '}
            {skipped === 'gaProperty' ? '' : 'Website Content Audit and '}
            Analytics & ROI!
          </div>
        </div>
        <div className={s.footer}>
          <Button type="link" onClick={onSkipConnection}>
            Finish Without Connecting
          </Button>
          {skipped === 'googleAccount' && (
            <GoogleIntegrationButton
              companyId={companyId}
              cta="Connect account"
            />
          )}
        </div>
      </div>
    </div>
  )
}
